import { createContext, useContext } from "react";
import { endOfDay } from "date-fns";
import { BillViewOptions, BillStats } from "@common/types/bill";
import { BillFilters } from "@common/contracts/bill.contract";

export type BillViewFilters = BillFilters & { billIds?: string[] };

export function toBillApiFilters(
    filters: BillViewFilters | undefined,
): BillFilters | undefined {
    if (!filters) {
        return undefined;
    }
    const { billIds, ...rest } = filters;
    const isAllTime = rest.start === undefined && rest.end !== undefined;

    return {
        ...rest,
        ...(isAllTime ? { end: endOfDay(new Date()) } : {}),
        ...(billIds ? { ids: billIds } : {}),
    };
}

interface BillsViewContextValue {
    filters: BillViewFilters | undefined;
    setFilters: React.Dispatch<
        React.SetStateAction<BillViewFilters | undefined>
    >;

    viewOption: BillViewOptions;
    setViewOption: React.Dispatch<React.SetStateAction<BillViewOptions>>;
    billStats?: BillStats;
    initialIds?: string[];
}

export const BillsViewContext = createContext<BillsViewContextValue | null>(
    null,
);

export function useBillsView() {
    const context = useContext(BillsViewContext);
    if (!context) {
        throw new Error("useBillsView must be used within BillsViewProvider");
    }
    return context;
}
